import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { Button } from "@mui/material";
import { COPY } from "@/constants/campaignContacts";
import { formatUsd } from "@/utils/number-format";
import { CONTACTS_TEXT_LINK_SX } from "./ContactsDialog";
import type { BudgetStripCopy } from "./types";

interface BudgetStripProps {
  giftsBudgeted: number;
  spacesFree: number;
  pricePerGift: number;
  /** Budget amendments so far; the history entry shows only once there is one. */
  amendmentCount: number;
  onOpenHistory: () => void;
  /** Wording override (the gift links modal says "links"); absent, the contacts wording. */
  copy?: BudgetStripCopy;
}

/** The contacts modal's toolbar summary: budget, free spaces, price, and the history entry. */
export default function BudgetStrip({
  giftsBudgeted,
  spacesFree,
  pricePerGift,
  amendmentCount,
  onOpenHistory,
  copy,
}: BudgetStripProps) {
  const T = copy ?? COPY.budgetStrip;
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[13px] text-graphite">
      <span className="font-bold text-rodeo-black">{T.budgeted(giftsBudgeted)}</span>
      {T.separator}
      <span>{T.free(spacesFree)}</span>
      {T.separator}
      <span>{T.perGift(formatUsd(pricePerGift))}</span>
      {amendmentCount > 0 && (
        <Button
          disableRipple
          onClick={onOpenHistory}
          startIcon={<HistoryOutlinedIcon sx={{ fontSize: 15 }} />}
          sx={CONTACTS_TEXT_LINK_SX}
        >
          {T.history}
        </Button>
      )}
    </div>
  );
}
